module.exports = __webpack_public_path__ + "static/media/medico.77d00db5.png";